<template>
  <div class="message-dialogue" :class="{ backdrop: backdrop }">
    <div class="dialogue-window" :appearance="compAppearance">
      <div class="banner">
        <img class="hands" :src="$assets.image.messages['registration_popup_hand.png']" alt="" />

        <transition name="fade" appear>
          <img class="check" :src="$assets.image.messages['registration_check.png']" alt="" />
        </transition>
      </div>

      <h1 class="title">Awesome!</h1>

      <ul class="message-list">
        <li class="message">Your registeration has been confirmed. Check your emails for details.</li>
      </ul>

      <button type="button" class="ok-button" @click="close">OK</button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import $assets from '@/assets';
import useMessagesStore from '@/stores/messages';

const props = defineProps({
  backdrop: {
    type: Boolean,
    default: null,
  },
  appearance: {
    type: Object,
    default: () => ({ w: 80, h: 70 }),
  },
});

const MessagesStore = useMessagesStore();

const compAppearance = computed(() => {
  return { h: props.appearance.h || 70, w: props.appearance.w || 80 };
});

function close() {
  MessagesStore.clearMessage();
}
</script>

<style scoped>
.message-dialogue {
  position: fixed;
  top: 0%;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
}

.backdrop {
  background-color: rgba(0, 0, 0, 0.6);
}

.dialogue-window {
  position: relative;
  width: 556px;
  /* height: 534px; */
  max-width: 80%;
  max-height: 90%;

  border-radius: 0.8em;
  overflow: hidden;

  font-size: 18px;
  text-align: center;
  color: #5c5c5c;

  background: #d6f8ff;
}

.banner {
  position: relative;
  width: 100%;
  height: 183px;
  overflow: hidden;

  background-image: linear-gradient(180deg, #56b4ff 0%, #28cede 97%);
}

@keyframes handsup {
  from {
    bottom: -57%;
  }

  to {
    bottom: 0%;
  }
}

.banner > .hands {
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translateX(-50%);
  height: 57%;

  animation: handsup 1s ease 0s 1;
}

.banner > .check {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translateX(-50%);
  height: 76%;
}

h1.title {
  font-size: 2em;
  color: inherit;
}

.message {
  margin: 1em 5em;
}

.ok-button {
  display: block;
  height: 2em;
  width: 10em;
  margin: 2em auto 2em auto;

  font-size: 21px;
  color: #ffffff;
  text-align: center;

  background-image: linear-gradient(180deg, #28cede 0%, #56b4ff 97%);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  border: none;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: bottom 5s;
}
.slide-up-enter,
.slide-up-leave-to {
  bottom: -57%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
